<template>
  <span>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M16.2365 14.9062C15.1657 13.0549 13.5154 11.7274 11.5896 11.0981C12.5422 10.531 13.2823 9.66686 13.6963 8.63841C14.1103 7.60996 14.1752 6.47405 13.8811 5.40513C13.587 4.33621 12.9502 3.39338 12.0684 2.72142C11.1866 2.04947 10.1086 1.68555 8.99998 1.68555C7.89134 1.68555 6.81335 2.04947 5.93156 2.72142C5.04976 3.39338 4.41293 4.33621 4.11884 5.40513C3.82476 6.47405 3.88968 7.60996 4.30366 8.63841C4.71763 9.66686 5.45775 10.531 6.41037 11.0981C4.48451 11.7267 2.83427 13.0542 1.76341 14.9062C1.72414 14.9702 1.6981 15.0415 1.68681 15.1158C1.67552 15.19 1.67922 15.2658 1.69769 15.3386C1.71616 15.4114 1.74902 15.4798 1.79435 15.5397C1.83967 15.5996 1.89653 15.6498 1.96157 15.6874C2.02662 15.7249 2.09853 15.7491 2.17306 15.7584C2.24759 15.7678 2.32324 15.7621 2.39554 15.7417C2.46784 15.7213 2.53532 15.6867 2.59401 15.6398C2.65269 15.5929 2.7014 15.5347 2.73724 15.4687C4.06193 13.1793 6.40334 11.8125 8.99998 11.8125C11.5966 11.8125 13.938 13.1793 15.2627 15.4687C15.2986 15.5347 15.3473 15.5929 15.4059 15.6398C15.4646 15.6867 15.5321 15.7213 15.6044 15.7417C15.6767 15.7621 15.7524 15.7678 15.8269 15.7584C15.9014 15.7491 15.9733 15.7249 16.0384 15.6874C16.1034 15.6498 16.1603 15.5996 16.2056 15.5397C16.2509 15.4798 16.2838 15.4114 16.3023 15.3386C16.3207 15.2658 16.3244 15.19 16.3131 15.1158C16.3019 15.0415 16.2758 14.9702 16.2365 14.9062ZM5.06248 6.74996C5.06248 5.9712 5.29341 5.20992 5.72607 4.5624C6.15872 3.91488 6.77368 3.4102 7.49316 3.11218C8.21264 2.81416 9.00435 2.73619 9.76815 2.88812C10.5319 3.04005 11.2335 3.41506 11.7842 3.96573C12.3349 4.5164 12.7099 5.21799 12.8618 5.98179C13.0137 6.74559 12.9358 7.53729 12.6378 8.25678C12.3397 8.97626 11.8351 9.59121 11.1875 10.0239C10.54 10.4565 9.77874 10.6875 8.99998 10.6875C7.95603 10.6863 6.95516 10.2711 6.21698 9.53296C5.47879 8.79478 5.06359 7.79391 5.06248 6.74996Z"
        :fill="strokeColor"
      />
    </svg>
  </span>
</template>
<script>
export default {
  name: 'User',
  props: {
    strokeColor: {
      type: String,
      default: '#6B7280',
    },
  },
};
</script>
